import React from 'react'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'

interface DetailProps {
  listAdjustment: any
}

export const ProvisionImpairmentAdjustmentDetailContent = (
  props: DetailProps
) => {
  const { listAdjustment } = props

  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Date
        </div>
        <div className="mdDesc text-noflow">
          {listAdjustment?.ProvisionImpair?.Date}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Provision Amount
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listAdjustment?.ProvisionImpair?.ProvisionAmount)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Description
        </div>
        <div className="mdDesc text-noflow">
          {listAdjustment?.ProvisionImpair?.Description}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="mdDesc text-noflow">
          {listAdjustment?.ProvisionImpair?.Reason}
        </div>
      </div>
    </>
  )
}
